<template>
  <div class="ui-detail-ctrl-prasie-wrapper">
    <div class="left" @click.stop="handleJumpContribute">
      <i class="icon-work"></i>
      <span>立即报名</span>
    </div>
    <div class="middle">
      <nf-praise
        :worksId="worksId"
        :hasPraised="hasPraised"
        @resfresPraise="handlePraise"
        @refreshLogin="handleRefreshWorkList"
        @backPraise="handleBackPraise"
      >
        <div class="praise-wrapper">
          <div class="heart-wrapper">
            <transition name="fade-toggle">
              <span class="icon icon-heart active" v-if="hasPraised" key="iconPraiseRed"></span>
              <span class="icon icon-heart" key="iconPraiseWhite" v-else></span>
            </transition>
          </div>
          <span class="praise-count">{{ praiseNum }}</span>
        </div>
      </nf-praise>
    </div>
    <div class="right" @click="handleShareWorkDetail">
      <i class="icon-share"></i>
      <span>分享</span>
    </div>
  </div>
</template>

<script>
import NfPraise from "@/components/NfPraise"

export default {
  name: "uiDetailCtrlPrasie",
  props: {
    worksId: {
      type: [String, Number],
      default: ""
    },
    hasPraised: {
      type: Boolean,
      default: false
    },
    praiseNum: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handlePraise() {
      this.$emit("resfresPraise")
    },
    handleBackPraise() {
      this.$emit("backPraise")
    },
    handleRefreshWorkList() {
      this.$emit("refreshLogin")
    },
    handleJumpContribute() {
      this.$emit("jumpContribute")
    },
    handleShareWorkDetail() {
      this.$emit("shareWorkDetail")
    }
  },
  components: {
    NfPraise
  }
}
</script>

<style lang="scss" scoped>
.ui-detail-ctrl-prasie-wrapper {
  width: 6.4rem;
  height: 0.88rem;
  background: #f64e45;
  border-radius: 0.44rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;
    .icon-work {
      margin-right: 0.08rem;
      width: 0.34rem;
      height: 0.34rem;
      background: url("../../../../assets/images/icon_contribute.png") no-repeat center;
      background-size: 100%;
    }
  }
  .middle {
    width: 1.6rem;
    flex: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &::before {
      content: "";
      height: 0.2rem;
      display: block;
      border-left: 1px solid #ffcaca;
    }
    &::after {
      content: "";
      height: 0.2rem;
      display: block;
      border-left: 1px solid #ffcaca;
    }
    .praise-wrapper {
      transform: translate3d(0, -0.25rem, 0);
      flex: none;
      width: 1.1rem;
      height: 1.1rem;
      border-radius: 50%;
      background: url("../../../../assets/images/btn_like_bg.png") no-repeat center;
      background-size: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: none;
      .heart-wrapper {
        margin-top: 0.19rem;
        width: 0.38rem;
        height: 0.38rem;
        position: relative;
      }
      .icon-heart {
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        width: 100%;
        height: 100%;
        background: url("../../../../assets/images/icon_like_n.png") no-repeat center;
        background-size: 100%;
        &.active {
          background: url("../../../../assets/images/icon_like_s.png") no-repeat center;
          background-size: 100%;
        }
      }
      .praise-count {
        margin-top: 0.05rem;
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        color: #666666;
        line-height: 0.33rem;
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;
    .icon-share {
      margin-right: 0.08rem;
      width: 0.34rem;
      height: 0.34rem;
      background: url("../../../../assets/images/icon_share_white.jpg") no-repeat center;
      background-size: 100%;
    }
  }
}
.fade-toggle-enter-active {
  animation: toggleScale 0.3s ease-in-out;
}
.fade-toggle-leave-active {
  transition: opacity 0.3s;
}
.fade-toggle-leave {
  opacity: 1;
}
.fade-toggle-leave-to {
  opacity: 0;
}
@keyframes toggleScale {
  0% {
    transform: scale3d(0.6, 0.6, 1);
    opacity: 0.3;
  }
  75% {
    transform: scale3d(1.2, 1.2, 1);
    opacity: 1;
  }
  100% {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}
</style>
